import { CARREGAR_TIPO_DE_DEFICIENCIA_SUCESSO } from './actionTypes';
import ITipoDeDeficiencia from '../interfaces/ITipoDeDeficiencia';

export const carregarTiposDeDeficiencia = (tiposDeDeficiencia: ITipoDeDeficiencia[]) => {
  return {
    type: CARREGAR_TIPO_DE_DEFICIENCIA_SUCESSO,
    state: tiposDeDeficiencia
  };
};